import {getTestProps} from '@benchling/js-test-utils';
import {css} from 'aphrodite';
import classNames from 'classnames';
import React from 'react';

import * as BenchlingUtil from 'BenchlingUtil';
import DevToolsIcon from 'dev/DevToolsIcon';
import {makeNavbarBackgroundStyles} from 'nav/navbar/NavBarColor';
import * as SidepanelActions from 'nav/sidepanel/SidepanelActions';

import HomeIcon from './HomeIcon';
import {navBarContentsStyles} from './NavBarContents';

export default function SettingsNavBarContents(): JSX.Element {
  return (
    <div
      style={makeNavbarBackgroundStyles()}
      className={classNames(
        css(navBarContentsStyles.navbar, window.impersonating && navBarContentsStyles.impersonating),
        'js-navTour-nav'
      )}
      role="tablist"
      {...getTestProps({component: 'SettingsNavBarContents', element: 'root'})}
    >
      <HomeIcon
        icon="benchling"
        isActive={false}
        onHomeIconClick={(_section, e) => {
          BenchlingUtil.navigate(e, '/editor');
          SidepanelActions.close();
        }}
      />
      {window.debug && <DevToolsIcon />}
    </div>
  );
}
